import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { getGuardianChainForEnsuringAuthOnboardedAndActive } from "@/router/guardian-utils"
import { ensureHasActiveOrUpcomingBenefitsGuardian } from "@/router/guardians"

export const routes = [
  {
    path: "/benefits",
    name: "my-benefits",
    component: () => import("@/modules/benefits/pages/my-benefits/MyBenefitsPage.vue"),
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.runGuardians(to, from, next, [
        ...getGuardianChainForEnsuringAuthOnboardedAndActive(),
        ensureHasActiveOrUpcomingBenefitsGuardian
      ])
    }
  },
  {
    path: "/benefits/:companyBenefitId",
    name: "benefit-summary",
    component: () => import("@/modules/benefits/pages/benefit-summary/BenefitSummary.vue"),
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.runGuardians(to, from, next, [
        ...getGuardianChainForEnsuringAuthOnboardedAndActive(),
        ensureHasActiveOrUpcomingBenefitsGuardian
      ])
    },
    props: true
  },
  {
    path: "/benefits/bank-accounts",
    name: "bank-accounts",
    component: () => import("@/modules/benefits/pages/bank-accounts/BankAccounts.vue"),
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.runGuardians(to, from, next, [
        ...getGuardianChainForEnsuringAuthOnboardedAndActive(),
        ensureHasActiveOrUpcomingBenefitsGuardian
      ])
    }
  }
]

export const noLayoutRoutes = [
  {
    path: "/benefits/hra-onboarding",
    name: "hra-onboarding",
    component: () => import("@/modules/benefits/pages/hra-onboarding/HraOnboarding.vue"),
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.runGuardians(to, from, next, [
        ...getGuardianChainForEnsuringAuthOnboardedAndActive(),
        ensureHasActiveOrUpcomingBenefitsGuardian
      ])
    },
    props: true
  }
]
